const API_EVENT = {
    STORE_EVENT_URL: '/api/v4/event/store' 
}

const API_USER = {
    REPORT_USER_URL: (userName) => `/api/v4/user/report/${userName}`,
    BLOCK_USER_URL: (userId) => `/api/v4/user/block/${userId}`,
    UNBLOCK_USER_URL: (userId) => `/api/v4/user/block/${userId}`,
}

const API_PRODUCT = {
    REPORT_PRODUCT_URL: (uuid) => `/api/v5/products/${uuid}/reports`,
    PRICE_COMMISSION_URL: (productId, price) => `/api/v6/products/${productId}/price-commission?price=${price}`,
    INFO_PRODUCT_URL: (productId) => `/api/v5/products/${productId}`,
    SIMILAR_PRODUCT_URL: (category, brand, status) => `/api/v5/products/similar?category=${category}&brand=${brand}&status=${status}`
}

export { API_EVENT, API_USER, API_PRODUCT };